const e=async(e,t,n)=>{await e.put(`/roles/${t}`,n)};export{e as updateRole};
//# sourceMappingURL=update-role.mjs.map